import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard'

const routes: Routes = [

  {
    path: '',
    redirectTo: 'city-home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/auth/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login/:redirect',
    loadChildren: () => import('./pages/auth/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/auth/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'recover',
    loadChildren: () => import('./pages/auth/recover/recover.module').then( m => m.RecoverPageModule)
  },
  {
    path: 'home',
    redirectTo: 'city-home',
    pathMatch: 'full',
  },
  {
    path: 'items/:store',
    loadChildren: () => import('./pages/items/items.module').then( m => m.ItemsPageModule),
    // canActivate: [AuthGuard]
  },
  {
    path: 'restaurant/:store',
    loadChildren: () => import('./pages/restaurant/restaurant.module').then( m => m.RestaurantPageModule),
    // canActivate: [AuthGuard]
  },
  {
    path: 'orders',
    loadChildren: () => import('./pages/acount/orders/orders.module').then( m => m.OrdersPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/acount/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cart',
    loadChildren: () => import('./pages/cart/cart.module').then( m => m.CartPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'end-purchase',
    loadChildren: () => import('./pages/end-purchase/end-purchase.module').then( m => m.EndPurchasePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'order-status',
    loadChildren: () => import('./pages/order-status/order-status.module').then( m => m.OrderStatusPageModule)
  },
  {
    path: 'order-status/:order',
    loadChildren: () => import('./pages/order-status/order-status.module').then( m => m.OrderStatusPageModule)
  },
  {
    path: 'stores/:category',
    loadChildren: () => import('./pages/stores/stores.module').then( m => m.StoresPageModule)
  },
  {
    path: 'city-home',
    loadChildren: () => import('./pages/city-home/city-home.module').then( m => m.CityHomePageModule)
  },
  {
    path: '**',
    redirectTo: 'city-home',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }

